// This file is auto-generated by @hey-api/openapi-ts

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape, urlSearchParamsBodySerializer } from './client';
import { client } from './client.gen';
import type { BudgetCategorysCreateBudgetCategoryData, BudgetCategorysCreateBudgetCategoryErrors, BudgetCategorysCreateBudgetCategoryResponses, BudgetCategorysDeleteBudgetCategoryData, BudgetCategorysDeleteBudgetCategoryErrors, BudgetCategorysDeleteBudgetCategoryResponses, BudgetCategorysReadBudgetCategoryData, BudgetCategorysReadBudgetCategoryErrors, BudgetCategorysReadBudgetCategoryResponses, BudgetCategorysReadBudgetCategorysData, BudgetCategorysReadBudgetCategorysErrors, BudgetCategorysReadBudgetCategorysResponses, BudgetCategorysUpdateBudgetCategoryData, BudgetCategorysUpdateBudgetCategoryErrors, BudgetCategorysUpdateBudgetCategoryResponses, BudgetCategoryTypesCreateBudgetCategoryTypeData, BudgetCategoryTypesCreateBudgetCategoryTypeErrors, BudgetCategoryTypesCreateBudgetCategoryTypeResponses, BudgetCategoryTypesDeleteBudgetCategoryTypeData, BudgetCategoryTypesDeleteBudgetCategoryTypeErrors, BudgetCategoryTypesDeleteBudgetCategoryTypeResponses, BudgetCategoryTypesGetBudgetCategoryTypeData, BudgetCategoryTypesGetBudgetCategoryTypeErrors, BudgetCategoryTypesGetBudgetCategoryTypeResponses, BudgetCategoryTypesListBudgetCategoryTypesData, BudgetCategoryTypesListBudgetCategoryTypesErrors, BudgetCategoryTypesListBudgetCategoryTypesResponses, BudgetCategoryTypesUpdateBudgetCategoryTypeData, BudgetCategoryTypesUpdateBudgetCategoryTypeErrors, BudgetCategoryTypesUpdateBudgetCategoryTypeResponses, ClientAllowedServiceTypesAddAllowedServiceTypeData, ClientAllowedServiceTypesAddAllowedServiceTypeErrors, ClientAllowedServiceTypesAddAllowedServiceTypeResponses, ClientAllowedServiceTypesApplyClientTypeData, ClientAllowedServiceTypesApplyClientTypeErrors, ClientAllowedServiceTypesApplyClientTypeResponses, ClientAllowedServiceTypesListAllowedServiceTypesData, ClientAllowedServiceTypesListAllowedServiceTypesErrors, ClientAllowedServiceTypesListAllowedServiceTypesResponses, ClientAllowedServiceTypesRemoveAllowedServiceTypeData, ClientAllowedServiceTypesRemoveAllowedServiceTypeErrors, ClientAllowedServiceTypesRemoveAllowedServiceTypeResponses, ClientBudgetsCreateClientBudgetData, ClientBudgetsCreateClientBudgetErrors, ClientBudgetsCreateClientBudgetResponses, ClientBudgetsDeleteClientBudgetData, ClientBudgetsDeleteClientBudgetErrors, ClientBudgetsDeleteClientBudgetResponses, ClientBudgetsGetClientBudgetData, ClientBudgetsGetClientBudgetErrors, ClientBudgetsGetClientBudgetResponses, ClientBudgetsListClientBudgetsData, ClientBudgetsListClientBudgetsErrors, ClientBudgetsListClientBudgetsResponses, ClientBudgetsUpdateClientBudgetData, ClientBudgetsUpdateClientBudgetErrors, ClientBudgetsUpdateClientBudgetResponses, ClientPurchasesCreatePurchaseOrderData, ClientPurchasesCreatePurchaseOrderErrors, ClientPurchasesCreatePurchaseOrderResponses, ClientPurchasesListPurchasesByClientData, ClientPurchasesListPurchasesByClientErrors, ClientPurchasesListPurchasesByClientResponses, ClientPurchasesVoidPurchaseData, ClientPurchasesVoidPurchaseErrors, ClientPurchasesVoidPurchaseResponses, CoContributionDefaultsDeleteDefaultData, CoContributionDefaultsDeleteDefaultErrors, CoContributionDefaultsDeleteDefaultResponses, CoContributionDefaultsListDefaultsData, CoContributionDefaultsListDefaultsErrors, CoContributionDefaultsListDefaultsResponses, CoContributionDefaultsUpsertDefaultData, CoContributionDefaultsUpsertDefaultErrors, CoContributionDefaultsUpsertDefaultResponses, DashboardGetProviderDashboardStatsData, DashboardGetProviderDashboardStatsErrors, DashboardGetProviderDashboardStatsResponses, DashboardGetProviderUserDashboardStatsData, DashboardGetProviderUserDashboardStatsErrors, DashboardGetProviderUserDashboardStatsResponses, LoginLoginAccessTokenData, LoginLoginAccessTokenErrors, LoginLoginAccessTokenResponses, LoginRecoverPasswordData, LoginRecoverPasswordErrors, LoginRecoverPasswordHtmlContentData, LoginRecoverPasswordHtmlContentErrors, LoginRecoverPasswordHtmlContentResponses, LoginRecoverPasswordResponses, LoginResetPasswordData, LoginResetPasswordErrors, LoginResetPasswordResponses, LoginTestTokenData, LoginTestTokenResponses, PrivateCreateUserData, PrivateCreateUserErrors, PrivateCreateUserResponses, ProviderClientCoContributionsDeleteClientCoContributionData, ProviderClientCoContributionsDeleteClientCoContributionErrors, ProviderClientCoContributionsDeleteClientCoContributionResponses, ProviderClientCoContributionsListClientCoContributionsData, ProviderClientCoContributionsListClientCoContributionsErrors, ProviderClientCoContributionsListClientCoContributionsResponses, ProviderClientCoContributionsUpsertClientCoContributionData, ProviderClientCoContributionsUpsertClientCoContributionErrors, ProviderClientCoContributionsUpsertClientCoContributionResponses, ProviderClientsBulkImportProviderClientsData, ProviderClientsBulkImportProviderClientsErrors, ProviderClientsBulkImportProviderClientsResponses, ProviderClientsCreateProviderClientData, ProviderClientsCreateProviderClientErrors, ProviderClientsCreateProviderClientResponses, ProviderClientsCreateProviderClientWebUserData, ProviderClientsCreateProviderClientWebUserErrors, ProviderClientsCreateProviderClientWebUserResponses, ProviderClientsDeleteProviderClientData, ProviderClientsDeleteProviderClientErrors, ProviderClientsDeleteProviderClientResponses, ProviderClientsReadProviderClientByIdData, ProviderClientsReadProviderClientByIdErrors, ProviderClientsReadProviderClientByIdResponses, ProviderClientsReadProviderClientsByProviderIdData, ProviderClientsReadProviderClientsByProviderIdErrors, ProviderClientsReadProviderClientsByProviderIdResponses, ProviderClientsReadProviderClientsByUserId2Data, ProviderClientsReadProviderClientsByUserId2Errors, ProviderClientsReadProviderClientsByUserId2Responses, ProviderClientsReadProviderClientsByUserIdData, ProviderClientsReadProviderClientsByUserIdErrors, ProviderClientsReadProviderClientsByUserIdResponses, ProviderClientsUpdateProviderClientData, ProviderClientsUpdateProviderClientErrors, ProviderClientsUpdateProviderClientResponses, ProviderClientTypesAddClientTypeSurveyData, ProviderClientTypesAddClientTypeSurveyErrors, ProviderClientTypesAddClientTypeSurveyResponses, ProviderClientTypesAddServiceDefaultData, ProviderClientTypesAddServiceDefaultErrors, ProviderClientTypesAddServiceDefaultResponses, ProviderClientTypesCreateProviderClientTypeData, ProviderClientTypesCreateProviderClientTypeErrors, ProviderClientTypesCreateProviderClientTypeResponses, ProviderClientTypesDeleteProviderClientTypeData, ProviderClientTypesDeleteProviderClientTypeErrors, ProviderClientTypesDeleteProviderClientTypeResponses, ProviderClientTypesListClientTypeSurveysData, ProviderClientTypesListClientTypeSurveysErrors, ProviderClientTypesListClientTypeSurveysResponses, ProviderClientTypesListProviderClientTypesData, ProviderClientTypesListProviderClientTypesErrors, ProviderClientTypesListProviderClientTypesResponses, ProviderClientTypesListServiceDefaultsData, ProviderClientTypesListServiceDefaultsErrors, ProviderClientTypesListServiceDefaultsResponses, ProviderClientTypesRemoveClientTypeSurveyData, ProviderClientTypesRemoveClientTypeSurveyErrors, ProviderClientTypesRemoveClientTypeSurveyResponses, ProviderClientTypesRemoveServiceDefaultData, ProviderClientTypesRemoveServiceDefaultErrors, ProviderClientTypesRemoveServiceDefaultResponses, ProviderClientTypesUpdateProviderClientTypeData, ProviderClientTypesUpdateProviderClientTypeErrors, ProviderClientTypesUpdateProviderClientTypeResponses, ProviderGroupsCreateProviderGroupData, ProviderGroupsCreateProviderGroupErrors, ProviderGroupsCreateProviderGroupResponses, ProviderGroupsDeleteProviderGroupData, ProviderGroupsDeleteProviderGroupErrors, ProviderGroupsDeleteProviderGroupResponses, ProviderGroupsReadProviderGroupData, ProviderGroupsReadProviderGroupErrors, ProviderGroupsReadProviderGroupResponses, ProviderGroupsReadProviderGroupsByProviderIdData, ProviderGroupsReadProviderGroupsByProviderIdErrors, ProviderGroupsReadProviderGroupsByProviderIdResponses, ProviderGroupsUpdateProviderGroupData, ProviderGroupsUpdateProviderGroupErrors, ProviderGroupsUpdateProviderGroupResponses, ProviderItemOverridesCreateOverrideData, ProviderItemOverridesCreateOverrideErrors, ProviderItemOverridesCreateOverrideResponses, ProviderItemOverridesDeleteOverrideData, ProviderItemOverridesDeleteOverrideErrors, ProviderItemOverridesDeleteOverrideResponses, ProviderItemOverridesGetOverrideData, ProviderItemOverridesGetOverrideErrors, ProviderItemOverridesGetOverrideResponses, ProviderItemOverridesListOverridesByProviderData, ProviderItemOverridesListOverridesByProviderErrors, ProviderItemOverridesListOverridesByProviderResponses, ProviderItemOverridesUpdateOverrideData, ProviderItemOverridesUpdateOverrideErrors, ProviderItemOverridesUpdateOverrideResponses, ProviderItemsReadProviderItemsByClientData, ProviderItemsReadProviderItemsByClientErrors, ProviderItemsReadProviderItemsByClientResponses, ProviderItemsReadProviderItemsByProviderData, ProviderItemsReadProviderItemsByProviderErrors, ProviderItemsReadProviderItemsByProviderResponses, ProvidersCreateProviderData, ProvidersCreateProviderErrors, ProvidersCreateProviderResponses, ProvidersCreateProviderVendorOverrideData, ProvidersCreateProviderVendorOverrideErrors, ProvidersCreateProviderVendorOverrideResponses, ProvidersDeleteProviderData, ProvidersDeleteProviderErrors, ProvidersDeleteProviderResponses, ProvidersGetProviderVendorOverridesData, ProvidersGetProviderVendorOverridesResponses, ProvidersReadProvidersData, ProvidersReadProvidersErrors, ProvidersReadProvidersResponses, ProvidersReadSingleProviderData, ProvidersReadSingleProviderErrors, ProvidersReadSingleProviderResponses, ProvidersUpdateProviderData, ProvidersUpdateProviderErrors, ProvidersUpdateProviderResponses, ProviderUserGroupsAddProviderUserToProviderGroupData, ProviderUserGroupsAddProviderUserToProviderGroupErrors, ProviderUserGroupsAddProviderUserToProviderGroupResponses, ProviderUserGroupsMembershipReadProviderUserGroupsData, ProviderUserGroupsMembershipReadProviderUserGroupsErrors, ProviderUserGroupsMembershipReadProviderUserGroupsResponses, ProviderUserGroupsReadProviderUserGroupMembershipData, ProviderUserGroupsReadProviderUserGroupMembershipErrors, ProviderUserGroupsReadProviderUserGroupMembershipResponses, ProviderUserGroupsRemoveProviderUserFromProviderGroupData, ProviderUserGroupsRemoveProviderUserFromProviderGroupErrors, ProviderUserGroupsRemoveProviderUserFromProviderGroupResponses, ProviderUsersCreateProviderUserData, ProviderUsersCreateProviderUserErrors, ProviderUsersCreateProviderUserResponses, ProviderUsersDeleteProviderUserData, ProviderUsersDeleteProviderUserErrors, ProviderUsersDeleteProviderUserResponses, ProviderUsersReadProviderUserData, ProviderUsersReadProviderUserErrors, ProviderUsersReadProviderUserResponses, ProviderUsersReadProviderUsersByUserIdData, ProviderUsersReadProviderUsersByUserIdErrors, ProviderUsersReadProviderUsersByUserIdResponses, ProviderUsersReadProviderUsersData, ProviderUsersReadProviderUsersErrors, ProviderUsersReadProviderUsersResponses, ProviderUsersUpdateProviderUserData, ProviderUsersUpdateProviderUserErrors, ProviderUsersUpdateProviderUserResponses, ProviderUserTypesCreateProviderUserTypeData, ProviderUserTypesCreateProviderUserTypeErrors, ProviderUserTypesCreateProviderUserTypeResponses, ProviderUserTypesDeleteProviderUserTypeData, ProviderUserTypesDeleteProviderUserTypeErrors, ProviderUserTypesDeleteProviderUserTypeResponses, ProviderUserTypesListProviderUserTypesData, ProviderUserTypesListProviderUserTypesErrors, ProviderUserTypesListProviderUserTypesResponses, ProviderUserTypesUpdateProviderUserTypeData, ProviderUserTypesUpdateProviderUserTypeErrors, ProviderUserTypesUpdateProviderUserTypeResponses, PurchaseCatalogCreatePurchaseItemData, PurchaseCatalogCreatePurchaseItemErrors, PurchaseCatalogCreatePurchaseItemResponses, PurchaseCatalogDeletePurchaseItemData, PurchaseCatalogDeletePurchaseItemErrors, PurchaseCatalogDeletePurchaseItemResponses, PurchaseCatalogGetPurchaseItemData, PurchaseCatalogGetPurchaseItemErrors, PurchaseCatalogGetPurchaseItemResponses, PurchaseCatalogListPurchaseItemsByProviderData, PurchaseCatalogListPurchaseItemsByProviderErrors, PurchaseCatalogListPurchaseItemsByProviderResponses, PurchaseCatalogListPurchaseItemsBySubcategoryData, PurchaseCatalogListPurchaseItemsBySubcategoryErrors, PurchaseCatalogListPurchaseItemsBySubcategoryResponses, PurchaseCatalogUpdatePurchaseItemData, PurchaseCatalogUpdatePurchaseItemErrors, PurchaseCatalogUpdatePurchaseItemResponses, ServiceCatalogAddItemUserTypeData, ServiceCatalogAddItemUserTypeErrors, ServiceCatalogAddItemUserTypeResponses, ServiceCatalogCreateServiceItemData, ServiceCatalogCreateServiceItemErrors, ServiceCatalogCreateServiceItemResponses, ServiceCatalogCreateSubcategoryData, ServiceCatalogCreateSubcategoryErrors, ServiceCatalogCreateSubcategoryResponses, ServiceCatalogDeleteServiceItemData, ServiceCatalogDeleteServiceItemErrors, ServiceCatalogDeleteServiceItemResponses, ServiceCatalogDeleteSubcategoryData, ServiceCatalogDeleteSubcategoryErrors, ServiceCatalogDeleteSubcategoryResponses, ServiceCatalogGetServiceItemData, ServiceCatalogGetServiceItemErrors, ServiceCatalogGetServiceItemResponses, ServiceCatalogGetSubcategoryData, ServiceCatalogGetSubcategoryErrors, ServiceCatalogGetSubcategoryResponses, ServiceCatalogListItemsBySubcategoryData, ServiceCatalogListItemsBySubcategoryErrors, ServiceCatalogListItemsBySubcategoryResponses, ServiceCatalogListItemsForClientData, ServiceCatalogListItemsForClientErrors, ServiceCatalogListItemsForClientResponses, ServiceCatalogListItemsForCurrentUserData, ServiceCatalogListItemsForCurrentUserErrors, ServiceCatalogListItemsForCurrentUserResponses, ServiceCatalogListItemsForUserTypeData, ServiceCatalogListItemsForUserTypeErrors, ServiceCatalogListItemsForUserTypeResponses, ServiceCatalogListItemUserTypesData, ServiceCatalogListItemUserTypesErrors, ServiceCatalogListItemUserTypesResponses, ServiceCatalogListSubcategoriesByProviderData, ServiceCatalogListSubcategoriesByProviderErrors, ServiceCatalogListSubcategoriesByProviderResponses, ServiceCatalogRemoveItemUserTypeData, ServiceCatalogRemoveItemUserTypeErrors, ServiceCatalogRemoveItemUserTypeResponses, ServiceCatalogUpdateServiceItemData, ServiceCatalogUpdateServiceItemErrors, ServiceCatalogUpdateServiceItemResponses, ServiceCatalogUpdateSubcategoryData, ServiceCatalogUpdateSubcategoryErrors, ServiceCatalogUpdateSubcategoryResponses, ServiceItemDeliveredCreateServiceItemDeliveredData, ServiceItemDeliveredCreateServiceItemDeliveredErrors, ServiceItemDeliveredCreateServiceItemDeliveredResponses, ServiceItemDeliveredDeleteServiceItemDeliveredData, ServiceItemDeliveredDeleteServiceItemDeliveredErrors, ServiceItemDeliveredDeleteServiceItemDeliveredResponses, ServiceItemDeliveredGetServiceItemDeliveredData, ServiceItemDeliveredGetServiceItemDeliveredErrors, ServiceItemDeliveredGetServiceItemDeliveredResponses, ServiceItemDeliveredListServiceItemDeliveredAuditData, ServiceItemDeliveredListServiceItemDeliveredAuditErrors, ServiceItemDeliveredListServiceItemDeliveredAuditResponses, ServiceItemDeliveredListServiceItemsDeliveredByProviderClientData, ServiceItemDeliveredListServiceItemsDeliveredByProviderClientErrors, ServiceItemDeliveredListServiceItemsDeliveredByProviderClientResponses, ServiceItemDeliveredUpdateServiceItemDeliveredData, ServiceItemDeliveredUpdateServiceItemDeliveredErrors, ServiceItemDeliveredUpdateServiceItemDeliveredResponses, ServiceItemProviderRatesDeleteRateData, ServiceItemProviderRatesDeleteRateErrors, ServiceItemProviderRatesDeleteRateResponses, ServiceItemProviderRatesGetAuditData, ServiceItemProviderRatesGetAuditErrors, ServiceItemProviderRatesGetAuditResponses, ServiceItemProviderRatesGetRateData, ServiceItemProviderRatesGetRateErrors, ServiceItemProviderRatesGetRateResponses, ServiceItemProviderRatesUpsertRateData, ServiceItemProviderRatesUpsertRateErrors, ServiceItemProviderRatesUpsertRateResponses, SupportAtHomeClassificationsListClassificationsData, SupportAtHomeClassificationsListClassificationsResponses, SurveyResponsesGetSurveyResponseData, SurveyResponsesGetSurveyResponseErrors, SurveyResponsesGetSurveyResponseGroupedData, SurveyResponsesGetSurveyResponseGroupedErrors, SurveyResponsesGetSurveyResponseGroupedResponses, SurveyResponsesGetSurveyResponseResponses, SurveyResponsesListSurveyResponsesData, SurveyResponsesListSurveyResponsesErrors, SurveyResponsesListSurveyResponsesGroupedByProviderClientData, SurveyResponsesListSurveyResponsesGroupedByProviderClientErrors, SurveyResponsesListSurveyResponsesGroupedByProviderClientResponses, SurveyResponsesListSurveyResponsesResponses, SurveyResponsesSubmitSurveyResponseData, SurveyResponsesSubmitSurveyResponseErrors, SurveyResponsesSubmitSurveyResponseResponses, SurveysCreateSurveyData, SurveysCreateSurveyErrors, SurveysCreateSurveyQuestionData, SurveysCreateSurveyQuestionErrors, SurveysCreateSurveyQuestionOptionData, SurveysCreateSurveyQuestionOptionErrors, SurveysCreateSurveyQuestionOptionResponses, SurveysCreateSurveyQuestionResponses, SurveysCreateSurveyResponses, SurveysDeleteSurveyData, SurveysDeleteSurveyErrors, SurveysDeleteSurveyQuestionData, SurveysDeleteSurveyQuestionErrors, SurveysDeleteSurveyQuestionOptionData, SurveysDeleteSurveyQuestionOptionErrors, SurveysDeleteSurveyQuestionOptionResponses, SurveysDeleteSurveyQuestionResponses, SurveysDeleteSurveyResponses, SurveysReadSurveyData, SurveysReadSurveyErrors, SurveysReadSurveyResponses, SurveysReadSurveysData, SurveysReadSurveysErrors, SurveysReadSurveysResponses, SurveysUpdateSurveyData, SurveysUpdateSurveyErrors, SurveysUpdateSurveyQuestionData, SurveysUpdateSurveyQuestionErrors, SurveysUpdateSurveyQuestionOptionData, SurveysUpdateSurveyQuestionOptionErrors, SurveysUpdateSurveyQuestionOptionResponses, SurveysUpdateSurveyQuestionResponses, SurveysUpdateSurveyResponses, UsersCreateUserData, UsersCreateUserErrors, UsersCreateUserResponses, UsersDeleteUserData, UsersDeleteUserErrors, UsersDeleteUserMeData, UsersDeleteUserMeResponses, UsersDeleteUserResponses, UsersReadUserByIdData, UsersReadUserByIdErrors, UsersReadUserByIdResponses, UsersReadUserMeData, UsersReadUserMeResponses, UsersReadUsersData, UsersReadUsersErrors, UsersReadUsersResponses, UsersRegisterUserData, UsersRegisterUserErrors, UsersRegisterUserResponses, UsersUpdatePasswordMeData, UsersUpdatePasswordMeErrors, UsersUpdatePasswordMeResponses, UsersUpdateUserData, UsersUpdateUserErrors, UsersUpdateUserMeData, UsersUpdateUserMeErrors, UsersUpdateUserMeResponses, UsersUpdateUserResponses, UtilsHealthCheckData, UtilsHealthCheckResponses, UtilsTestEmailData, UtilsTestEmailErrors, UtilsTestEmailResponses, VendorItemsCreateVendorItemData, VendorItemsCreateVendorItemErrors, VendorItemsCreateVendorItemResponses, VendorItemsDeleteProviderClientData, VendorItemsDeleteProviderClientErrors, VendorItemsDeleteProviderClientResponses, VendorItemsReadVendorItemsByVendorIdData, VendorItemsReadVendorItemsByVendorIdErrors, VendorItemsReadVendorItemsByVendorIdResponses, VendorItemsUpdateVendorItemData, VendorItemsUpdateVendorItemErrors, VendorItemsUpdateVendorItemResponses, VendorItemsUploadVendorItemsCsvData, VendorItemsUploadVendorItemsCsvErrors, VendorItemsUploadVendorItemsCsvResponses, VendorsCreateVendorData, VendorsCreateVendorErrors, VendorsCreateVendorResponses, VendorsDeleteVendorData, VendorsDeleteVendorErrors, VendorsDeleteVendorResponses, VendorsReadVendorData, VendorsReadVendorErrors, VendorsReadVendorResponses, VendorsReadVendorsData, VendorsReadVendorsErrors, VendorsReadVendorsResponses, VendorsUpdateVendorData, VendorsUpdateVendorErrors, VendorsUpdateVendorResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export class Login {
    /**
     * Login Access Token
     *
     * OAuth2 compatible token login, get an access token for future requests
     */
    public static loginAccessToken<ThrowOnError extends boolean = true>(options: Options<LoginLoginAccessTokenData, ThrowOnError>) {
        return (options.client ?? client).post<LoginLoginAccessTokenResponses, LoginLoginAccessTokenErrors, ThrowOnError, 'data'>({
            ...urlSearchParamsBodySerializer,
            url: '/api/v1/login/access-token',
            ...options,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                ...options.headers
            }
        });
    }
    
    /**
     * Test Token
     *
     * Test access token
     */
    public static testToken<ThrowOnError extends boolean = true>(options?: Options<LoginTestTokenData, ThrowOnError>) {
        return (options?.client ?? client).post<LoginTestTokenResponses, unknown, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/login/test-token',
            ...options
        });
    }
    
    /**
     * Recover Password
     *
     * Password Recovery
     */
    public static recoverPassword<ThrowOnError extends boolean = true>(options: Options<LoginRecoverPasswordData, ThrowOnError>) {
        return (options.client ?? client).post<LoginRecoverPasswordResponses, LoginRecoverPasswordErrors, ThrowOnError, 'data'>({ url: '/api/v1/password-recovery/{email}', ...options });
    }
    
    /**
     * Reset Password
     *
     * Reset password
     */
    public static resetPassword<ThrowOnError extends boolean = true>(options: Options<LoginResetPasswordData, ThrowOnError>) {
        return (options.client ?? client).post<LoginResetPasswordResponses, LoginResetPasswordErrors, ThrowOnError, 'data'>({
            url: '/api/v1/reset-password/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Recover Password Html Content
     *
     * HTML Content for Password Recovery
     */
    public static recoverPasswordHtmlContent<ThrowOnError extends boolean = true>(options: Options<LoginRecoverPasswordHtmlContentData, ThrowOnError>) {
        return (options.client ?? client).post<LoginRecoverPasswordHtmlContentResponses, LoginRecoverPasswordHtmlContentErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/password-recovery-html-content/{email}',
            ...options
        });
    }
}

export class Users {
    /**
     * List platform users
     *
     * Returns a paginated list of all platform-level user accounts. Supports optional filtering by name/email and by provider membership. A user may appear as a worker or client across multiple providers.
     */
    public static readUsers<ThrowOnError extends boolean = true>(options?: Options<UsersReadUsersData, ThrowOnError>) {
        return (options?.client ?? client).get<UsersReadUsersResponses, UsersReadUsersErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/users/',
            ...options
        });
    }
    
    /**
     * Create a platform user
     *
     * Creates a new platform-level user account and sends a welcome email if email delivery is configured.
     */
    public static createUser<ThrowOnError extends boolean = true>(options: Options<UsersCreateUserData, ThrowOnError>) {
        return (options.client ?? client).post<UsersCreateUserResponses, UsersCreateUserErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/users/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete own account
     *
     * Permanently deletes the calling user's own account.
     */
    public static deleteUserMe<ThrowOnError extends boolean = true>(options?: Options<UsersDeleteUserMeData, ThrowOnError>) {
        return (options?.client ?? client).delete<UsersDeleteUserMeResponses, unknown, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/users/me',
            ...options
        });
    }
    
    /**
     * Get own profile
     *
     * Returns the calling user's profile including provider memberships and role information.
     */
    public static readUserMe<ThrowOnError extends boolean = true>(options?: Options<UsersReadUserMeData, ThrowOnError>) {
        return (options?.client ?? client).get<UsersReadUserMeResponses, unknown, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/users/me',
            ...options
        });
    }
    
    /**
     * Update own profile
     *
     * Updates the calling user's own name or email address.
     */
    public static updateUserMe<ThrowOnError extends boolean = true>(options: Options<UsersUpdateUserMeData, ThrowOnError>) {
        return (options.client ?? client).patch<UsersUpdateUserMeResponses, UsersUpdateUserMeErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/users/me',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Change own password
     *
     * Updates the calling user's password. Requires the current password for confirmation.
     */
    public static updatePasswordMe<ThrowOnError extends boolean = true>(options: Options<UsersUpdatePasswordMeData, ThrowOnError>) {
        return (options.client ?? client).patch<UsersUpdatePasswordMeResponses, UsersUpdatePasswordMeErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/users/me/password',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Register User
     *
     * Create new user without the need to be logged in.
     */
    public static registerUser<ThrowOnError extends boolean = true>(options: Options<UsersRegisterUserData, ThrowOnError>) {
        return (options.client ?? client).post<UsersRegisterUserResponses, UsersRegisterUserErrors, ThrowOnError, 'data'>({
            url: '/api/v1/users/signup',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete a user
     *
     * Permanently removes a platform user account. Cannot be used to delete your own account.
     */
    public static deleteUser<ThrowOnError extends boolean = true>(options: Options<UsersDeleteUserData, ThrowOnError>) {
        return (options.client ?? client).delete<UsersDeleteUserResponses, UsersDeleteUserErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/users/{user_id}',
            ...options
        });
    }
    
    /**
     * Get user by ID
     *
     * Returns a user's profile including provider memberships. Users may only retrieve their own profile; platform administrators may retrieve any user.
     */
    public static readUserById<ThrowOnError extends boolean = true>(options: Options<UsersReadUserByIdData, ThrowOnError>) {
        return (options.client ?? client).get<UsersReadUserByIdResponses, UsersReadUserByIdErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/users/{user_id}',
            ...options
        });
    }
    
    /**
     * Update a user
     *
     * Updates a platform user's account details such as name, email, and active status.
     */
    public static updateUser<ThrowOnError extends boolean = true>(options: Options<UsersUpdateUserData, ThrowOnError>) {
        return (options.client ?? client).patch<UsersUpdateUserResponses, UsersUpdateUserErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/users/{user_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class Utils {
    /**
     * Test Email
     *
     * Test emails.
     */
    public static testEmail<ThrowOnError extends boolean = true>(options: Options<UtilsTestEmailData, ThrowOnError>) {
        return (options.client ?? client).post<UtilsTestEmailResponses, UtilsTestEmailErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/utils/test-email/',
            ...options
        });
    }
    
    /**
     * Health Check
     */
    public static healthCheck<ThrowOnError extends boolean = true>(options?: Options<UtilsHealthCheckData, ThrowOnError>) {
        return (options?.client ?? client).get<UtilsHealthCheckResponses, unknown, ThrowOnError, 'data'>({ url: '/api/v1/utils/health-check/', ...options });
    }
}

export class Providers {
    /**
     * Delete Provider
     *
     * Delete a provider.
     */
    public static deleteProvider<ThrowOnError extends boolean = true>(options: Options<ProvidersDeleteProviderData, ThrowOnError>) {
        return (options.client ?? client).delete<ProvidersDeleteProviderResponses, ProvidersDeleteProviderErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider/{id}',
            ...options
        });
    }
    
    /**
     * Get a provider by ID
     *
     * Returns the full details of a single provider organisation.
     */
    public static readSingleProvider<ThrowOnError extends boolean = true>(options: Options<ProvidersReadSingleProviderData, ThrowOnError>) {
        return (options.client ?? client).get<ProvidersReadSingleProviderResponses, ProvidersReadSingleProviderErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider/{id}',
            ...options
        });
    }
    
    /**
     * Update Provider
     *
     * Update a provider.
     */
    public static updateProvider<ThrowOnError extends boolean = true>(options: Options<ProvidersUpdateProviderData, ThrowOnError>) {
        return (options.client ?? client).put<ProvidersUpdateProviderResponses, ProvidersUpdateProviderErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Create a provider
     *
     * Registers a new provider organisation on the platform.
     */
    public static createProvider<ThrowOnError extends boolean = true>(options: Options<ProvidersCreateProviderData, ThrowOnError>) {
        return (options.client ?? client).post<ProvidersCreateProviderResponses, ProvidersCreateProviderErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List providers
     *
     * Returns the providers the calling user belongs to. Platform administrators receive the full list. All other authenticated users receive only the provider(s) they are a member of.
     */
    public static readProviders<ThrowOnError extends boolean = true>(options?: Options<ProvidersReadProvidersData, ThrowOnError>) {
        return (options?.client ?? client).get<ProvidersReadProvidersResponses, ProvidersReadProvidersErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/providers/',
            ...options
        });
    }
    
    /**
     * Get Provider Vendor Overrides
     *
     * Get all provider vendor overrides.
     */
    public static getProviderVendorOverrides<ThrowOnError extends boolean = true>(options?: Options<ProvidersGetProviderVendorOverridesData, ThrowOnError>) {
        return (options?.client ?? client).get<ProvidersGetProviderVendorOverridesResponses, unknown, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/providervendoroverride/',
            ...options
        });
    }
    
    /**
     * Create Provider Vendor Override
     *
     * Create a new provider vendor override.
     */
    public static createProviderVendorOverride<ThrowOnError extends boolean = true>(options: Options<ProvidersCreateProviderVendorOverrideData, ThrowOnError>) {
        return (options.client ?? client).post<ProvidersCreateProviderVendorOverrideResponses, ProvidersCreateProviderVendorOverrideErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/providervendoroverride/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class Dashboard {
    /**
     * Provider admin dashboard
     *
     * Returns a full overview of clients the calling user has access to: setup gaps (no budget, no services), upcoming birthdays, overdue services per service type, budgets at risk, and staff without a user-type or matching clients. Service overdue thresholds use the provider's configured interval per service item. ProviderGroupAdmin results are scoped to their assigned groups.
     */
    public static getProviderDashboardStats<ThrowOnError extends boolean = true>(options: Options<DashboardGetProviderDashboardStatsData, ThrowOnError>) {
        return (options.client ?? client).get<DashboardGetProviderDashboardStatsResponses, DashboardGetProviderDashboardStatsErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/dashboard/provider/stats',
            ...options
        });
    }
    
    /**
     * Worker personal dashboard
     *
     * Returns the calling user's personal client metrics scoped to their skill set: clients overdue per service type (with days since last delivery), clients with budgets at risk, and upcoming client birthdays. Available to any authenticated member of the provider. All lists are empty when no skill user-type has been assigned to the calling user.
     */
    public static getProviderUserDashboardStats<ThrowOnError extends boolean = true>(options: Options<DashboardGetProviderUserDashboardStatsData, ThrowOnError>) {
        return (options.client ?? client).get<DashboardGetProviderUserDashboardStatsResponses, DashboardGetProviderUserDashboardStatsErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/dashboard/provideruser/stats',
            ...options
        });
    }
}

export class ProviderGroups {
    /**
     * Delete Provider Group
     *
     * Delete a provider group.
     */
    public static deleteProviderGroup<ThrowOnError extends boolean = true>(options: Options<ProviderGroupsDeleteProviderGroupData, ThrowOnError>) {
        return (options.client ?? client).delete<ProviderGroupsDeleteProviderGroupResponses, ProviderGroupsDeleteProviderGroupErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-group/{id}',
            ...options
        });
    }
    
    /**
     * Read Provider Group
     *
     * Get Provider Group by ID.
     */
    public static readProviderGroup<ThrowOnError extends boolean = true>(options: Options<ProviderGroupsReadProviderGroupData, ThrowOnError>) {
        return (options.client ?? client).get<ProviderGroupsReadProviderGroupResponses, ProviderGroupsReadProviderGroupErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-group/{id}',
            ...options
        });
    }
    
    /**
     * Update Provider Group
     *
     * Update a provider group.
     */
    public static updateProviderGroup<ThrowOnError extends boolean = true>(options: Options<ProviderGroupsUpdateProviderGroupData, ThrowOnError>) {
        return (options.client ?? client).put<ProviderGroupsUpdateProviderGroupResponses, ProviderGroupsUpdateProviderGroupErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-group/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Create Provider Group
     *
     * Create new Provider Group.
     */
    public static createProviderGroup<ThrowOnError extends boolean = true>(options: Options<ProviderGroupsCreateProviderGroupData, ThrowOnError>) {
        return (options.client ?? client).post<ProviderGroupsCreateProviderGroupResponses, ProviderGroupsCreateProviderGroupErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-group/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Read Providergroups By Provider Id
     *
     * Get ProviderGroup by providerID.
     */
    public static readProviderGroupsByProviderId<ThrowOnError extends boolean = true>(options: Options<ProviderGroupsReadProviderGroupsByProviderIdData, ThrowOnError>) {
        return (options.client ?? client).get<ProviderGroupsReadProviderGroupsByProviderIdResponses, ProviderGroupsReadProviderGroupsByProviderIdErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-groups/{providerId}',
            ...options
        });
    }
}

export class ProviderClients {
    /**
     * Create Provider Client
     *
     * Create new Provider Client.
     */
    public static createProviderClient<ThrowOnError extends boolean = true>(options: Options<ProviderClientsCreateProviderClientData, ThrowOnError>) {
        return (options.client ?? client).post<ProviderClientsCreateProviderClientResponses, ProviderClientsCreateProviderClientErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-clients/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Create Provider Client Webuser
     *
     * Enable a Client for Web Access
     */
    public static createProviderClientWebUser<ThrowOnError extends boolean = true>(options: Options<ProviderClientsCreateProviderClientWebUserData, ThrowOnError>) {
        return (options.client ?? client).post<ProviderClientsCreateProviderClientWebUserResponses, ProviderClientsCreateProviderClientWebUserErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-clients/enablewebuser/{providerClientId}',
            ...options
        });
    }
    
    /**
     * Delete Provider Client
     *
     * Delete an item.
     */
    public static deleteProviderClient<ThrowOnError extends boolean = true>(options: Options<ProviderClientsDeleteProviderClientData, ThrowOnError>) {
        return (options.client ?? client).delete<ProviderClientsDeleteProviderClientResponses, ProviderClientsDeleteProviderClientErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-clients/{id}',
            ...options
        });
    }
    
    /**
     * Get a single provider client by ID
     *
     * Returns a provider client record. ProviderAdmin can access any client within their provider. ProviderGroupAdmin can access clients within their assigned groups. ProviderUser can access clients in their assigned groups whose allowed service types overlap with their skill set. Returns 404 when the client does not exist.
     */
    public static readProviderClientById<ThrowOnError extends boolean = true>(options: Options<ProviderClientsReadProviderClientByIdData, ThrowOnError>) {
        return (options.client ?? client).get<ProviderClientsReadProviderClientByIdResponses, ProviderClientsReadProviderClientByIdErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-clients/{id}',
            ...options
        });
    }
    
    /**
     * Update Provider Client
     *
     * Update a provider.
     */
    public static updateProviderClient<ThrowOnError extends boolean = true>(options: Options<ProviderClientsUpdateProviderClientData, ThrowOnError>) {
        return (options.client ?? client).put<ProviderClientsUpdateProviderClientResponses, ProviderClientsUpdateProviderClientErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-clients/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List provider clients by provider
     *
     * Returns all clients for a given provider. ProviderAdmin receives all clients within the provider. ProviderGroupAdmin receives only clients in the groups they administer; if providerGroupId is supplied it must be one of their admin groups. ProviderUser cannot access this endpoint.
     */
    public static readProviderClientsByProviderId<ThrowOnError extends boolean = true>(options: Options<ProviderClientsReadProviderClientsByProviderIdData, ThrowOnError>) {
        return (options.client ?? client).get<ProviderClientsReadProviderClientsByProviderIdResponses, ProviderClientsReadProviderClientsByProviderIdErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-clients/provider/{providerId}',
            ...options
        });
    }
    
    /**
     * Skill-matched clients for the calling user
     *
     * Returns clients whose allowed service types overlap with the calling user's skill set. ProviderAdmin receives all skill-matched clients within their provider. ProviderGroupAdmin and ProviderUser receive skill-matched clients within their assigned groups only. Returns an empty list when no skill user-type has been assigned to the calling user, including SuperUser.
     */
    public static readProviderClientsByUserId<ThrowOnError extends boolean = true>(options?: Options<ProviderClientsReadProviderClientsByUserIdData, ThrowOnError>) {
        return (options?.client ?? client).get<ProviderClientsReadProviderClientsByUserIdResponses, ProviderClientsReadProviderClientsByUserIdErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-clients/user/',
            ...options
        });
    }
    
    /**
     * Read Provider Clients By User Id
     *
     * Superuser only — get all ProviderClient records linked to the given platform user across all providers.
     */
    public static readProviderClientsByUserId2<ThrowOnError extends boolean = true>(options: Options<ProviderClientsReadProviderClientsByUserId2Data, ThrowOnError>) {
        return (options.client ?? client).get<ProviderClientsReadProviderClientsByUserId2Responses, ProviderClientsReadProviderClientsByUserId2Errors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-clients/for-user/{userId}',
            ...options
        });
    }
    
    /**
     * Bulk import provider clients from CSV
     *
     * Accepts a CSV file and creates provider clients in bulk. Secured to ProviderAdmin and SuperUser only. Returns a summary of rows created and any rows that failed validation or lookup, with per-row error details. The entire import is not atomic — valid rows are saved even when others fail. Required CSV columns: providerClientId, providerGroupName. Optional budget columns (all-or-nothing): SupportAtHomeBudgetClassification, BudgetAmount, BudgetStartDate, BudgetEndDate.
     */
    public static bulkImportProviderClients<ThrowOnError extends boolean = true>(options: Options<ProviderClientsBulkImportProviderClientsData, ThrowOnError>) {
        return (options.client ?? client).post<ProviderClientsBulkImportProviderClientsResponses, ProviderClientsBulkImportProviderClientsErrors, ThrowOnError, 'data'>({
            ...formDataBodySerializer,
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-clients/bulk-import',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
}

export class ProviderUsers {
    /**
     * Remove a staff member from a provider
     *
     * Removes a worker from the provider and all of their group memberships. The underlying platform user account is not deleted.
     */
    public static deleteProviderUser<ThrowOnError extends boolean = true>(options: Options<ProviderUsersDeleteProviderUserData, ThrowOnError>) {
        return (options.client ?? client).delete<ProviderUsersDeleteProviderUserResponses, ProviderUsersDeleteProviderUserErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-user/{id}',
            ...options
        });
    }
    
    /**
     * Get a provider staff member
     *
     * Returns the profile of a single worker registered under a provider, including their group memberships.
     */
    public static readProviderUser<ThrowOnError extends boolean = true>(options: Options<ProviderUsersReadProviderUserData, ThrowOnError>) {
        return (options.client ?? client).get<ProviderUsersReadProviderUserResponses, ProviderUsersReadProviderUserErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-user/{id}',
            ...options
        });
    }
    
    /**
     * Update a provider staff member
     *
     * Updates a worker's details, admin flag, display name override, and group memberships. Group membership changes are applied as a full replacement of the provided list.
     */
    public static updateProviderUser<ThrowOnError extends boolean = true>(options: Options<ProviderUsersUpdateProviderUserData, ThrowOnError>) {
        return (options.client ?? client).put<ProviderUsersUpdateProviderUserResponses, ProviderUsersUpdateProviderUserErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-user/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Add a staff member to a provider
     *
     * Registers a worker under a provider. If no platform account exists for the given email, one is created automatically. Optionally assigns the worker to a provider group at creation time.
     */
    public static createProviderUser<ThrowOnError extends boolean = true>(options: Options<ProviderUsersCreateProviderUserData, ThrowOnError>) {
        return (options.client ?? client).post<ProviderUsersCreateProviderUserResponses, ProviderUsersCreateProviderUserErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-user/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List provider staff members
     *
     * Returns workers registered under a provider, optionally filtered by group, individual, or service item skill requirements. When serviceItemId is supplied, only workers whose user types match the item's required types are returned. Group-scoped administrators only see workers within their assigned groups.
     */
    public static readProviderUsers<ThrowOnError extends boolean = true>(options: Options<ProviderUsersReadProviderUsersData, ThrowOnError>) {
        return (options.client ?? client).get<ProviderUsersReadProviderUsersResponses, ProviderUsersReadProviderUsersErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-users/',
            ...options
        });
    }
    
    /**
     * Read Provider Users By User Id
     *
     * Superuser only — get all ProviderUser records for the given platform user across all providers.
     */
    public static readProviderUsersByUserId<ThrowOnError extends boolean = true>(options: Options<ProviderUsersReadProviderUsersByUserIdData, ThrowOnError>) {
        return (options.client ?? client).get<ProviderUsersReadProviderUsersByUserIdResponses, ProviderUsersReadProviderUsersByUserIdErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-users/for-user/{userId}',
            ...options
        });
    }
}

export class ProviderItems {
    /**
     * Read Provider Items By Client
     *
     * Get provider catalog for a logged-in client user.
     */
    public static readProviderItemsByClient<ThrowOnError extends boolean = true>(options?: Options<ProviderItemsReadProviderItemsByClientData, ThrowOnError>) {
        return (options?.client ?? client).get<ProviderItemsReadProviderItemsByClientResponses, ProviderItemsReadProviderItemsByClientErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-items/',
            ...options
        });
    }
    
    /**
     * Read Provider Items By Provider
     *
     * Get provider catalog for provider staff.
     */
    public static readProviderItemsByProvider<ThrowOnError extends boolean = true>(options: Options<ProviderItemsReadProviderItemsByProviderData, ThrowOnError>) {
        return (options.client ?? client).get<ProviderItemsReadProviderItemsByProviderResponses, ProviderItemsReadProviderItemsByProviderErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-items/user',
            ...options
        });
    }
}

export class Vendors {
    /**
     * Read Vendors
     *
     * Retrieve Vendors.
     */
    public static readVendors<ThrowOnError extends boolean = true>(options?: Options<VendorsReadVendorsData, ThrowOnError>) {
        return (options?.client ?? client).get<VendorsReadVendorsResponses, VendorsReadVendorsErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/vendors/',
            ...options
        });
    }
    
    /**
     * Create Vendor
     *
     * Create new Vendor.
     */
    public static createVendor<ThrowOnError extends boolean = true>(options: Options<VendorsCreateVendorData, ThrowOnError>) {
        return (options.client ?? client).post<VendorsCreateVendorResponses, VendorsCreateVendorErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/vendors/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Read Vendor
     *
     * Get Vendor by ID.
     */
    public static readVendor<ThrowOnError extends boolean = true>(options: Options<VendorsReadVendorData, ThrowOnError>) {
        return (options.client ?? client).get<VendorsReadVendorResponses, VendorsReadVendorErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/vendors/{vendorId}',
            ...options
        });
    }
    
    /**
     * Delete Vendor
     *
     * Delete a Vendor.
     */
    public static deleteVendor<ThrowOnError extends boolean = true>(options: Options<VendorsDeleteVendorData, ThrowOnError>) {
        return (options.client ?? client).delete<VendorsDeleteVendorResponses, VendorsDeleteVendorErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/vendors/{id}',
            ...options
        });
    }
    
    /**
     * Update Vendor
     *
     * Update a Vendor.
     */
    public static updateVendor<ThrowOnError extends boolean = true>(options: Options<VendorsUpdateVendorData, ThrowOnError>) {
        return (options.client ?? client).put<VendorsUpdateVendorResponses, VendorsUpdateVendorErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/vendors/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class VendorItems {
    /**
     * Create Vendor Item
     *
     * Create new Vendor Item.
     */
    public static createVendorItem<ThrowOnError extends boolean = true>(options: Options<VendorItemsCreateVendorItemData, ThrowOnError>) {
        return (options.client ?? client).post<VendorItemsCreateVendorItemResponses, VendorItemsCreateVendorItemErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/vendor-items/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Read Vendoritems By Vendor Id
     *
     * Get VendorItem by vendorID.
     */
    public static readVendorItemsByVendorId<ThrowOnError extends boolean = true>(options: Options<VendorItemsReadVendorItemsByVendorIdData, ThrowOnError>) {
        return (options.client ?? client).get<VendorItemsReadVendorItemsByVendorIdResponses, VendorItemsReadVendorItemsByVendorIdErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/vendor-items/{vendorId}',
            ...options
        });
    }
    
    /**
     * Delete Provider Client
     *
     * Delete an item.
     */
    public static deleteProviderClient<ThrowOnError extends boolean = true>(options: Options<VendorItemsDeleteProviderClientData, ThrowOnError>) {
        return (options.client ?? client).delete<VendorItemsDeleteProviderClientResponses, VendorItemsDeleteProviderClientErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/vendor-items/{id}',
            ...options
        });
    }
    
    /**
     * Update Vendor Item
     *
     * Update a vendor.
     */
    public static updateVendorItem<ThrowOnError extends boolean = true>(options: Options<VendorItemsUpdateVendorItemData, ThrowOnError>) {
        return (options.client ?? client).put<VendorItemsUpdateVendorItemResponses, VendorItemsUpdateVendorItemErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/vendor-items/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Upload Vendor Items Csv
     *
     * Accepts a CSV file upload and returns its contents as a list of dictionaries.
     */
    public static uploadVendorItemsCsv<ThrowOnError extends boolean = true>(options: Options<VendorItemsUploadVendorItemsCsvData, ThrowOnError>) {
        return (options.client ?? client).post<VendorItemsUploadVendorItemsCsvResponses, VendorItemsUploadVendorItemsCsvErrors, ThrowOnError, 'data'>({
            ...formDataBodySerializer,
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/vendor-items/upload_csv/',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
}

export class BudgetCategorys {
    /**
     * Read Budgetcategorys
     *
     * Retrieve BudgetCategorys.
     */
    public static readBudgetCategorys<ThrowOnError extends boolean = true>(options?: Options<BudgetCategorysReadBudgetCategorysData, ThrowOnError>) {
        return (options?.client ?? client).get<BudgetCategorysReadBudgetCategorysResponses, BudgetCategorysReadBudgetCategorysErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/BudgetCategorys/',
            ...options
        });
    }
    
    /**
     * Create Budgetcategory
     */
    public static createBudgetCategory<ThrowOnError extends boolean = true>(options: Options<BudgetCategorysCreateBudgetCategoryData, ThrowOnError>) {
        return (options.client ?? client).post<BudgetCategorysCreateBudgetCategoryResponses, BudgetCategorysCreateBudgetCategoryErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/BudgetCategorys/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Budgetcategory
     *
     * Delete an BudgetCategory.
     */
    public static deleteBudgetCategory<ThrowOnError extends boolean = true>(options: Options<BudgetCategorysDeleteBudgetCategoryData, ThrowOnError>) {
        return (options.client ?? client).delete<BudgetCategorysDeleteBudgetCategoryResponses, BudgetCategorysDeleteBudgetCategoryErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/BudgetCategorys/{id}',
            ...options
        });
    }
    
    /**
     * Read Budgetcategory
     *
     * Get BudgetCategory by ID.
     */
    public static readBudgetCategory<ThrowOnError extends boolean = true>(options: Options<BudgetCategorysReadBudgetCategoryData, ThrowOnError>) {
        return (options.client ?? client).get<BudgetCategorysReadBudgetCategoryResponses, BudgetCategorysReadBudgetCategoryErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/BudgetCategorys/{id}',
            ...options
        });
    }
    
    /**
     * Update Budgetcategory
     *
     * Update an BudgetCategory.
     */
    public static updateBudgetCategory<ThrowOnError extends boolean = true>(options: Options<BudgetCategorysUpdateBudgetCategoryData, ThrowOnError>) {
        return (options.client ?? client).put<BudgetCategorysUpdateBudgetCategoryResponses, BudgetCategorysUpdateBudgetCategoryErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/BudgetCategorys/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class CoContributionDefaults {
    /**
     * List Defaults
     */
    public static listDefaults<ThrowOnError extends boolean = true>(options?: Options<CoContributionDefaultsListDefaultsData, ThrowOnError>) {
        return (options?.client ?? client).get<CoContributionDefaultsListDefaultsResponses, CoContributionDefaultsListDefaultsErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/co-contribution-defaults/',
            ...options
        });
    }
    
    /**
     * Upsert Default
     */
    public static upsertDefault<ThrowOnError extends boolean = true>(options: Options<CoContributionDefaultsUpsertDefaultData, ThrowOnError>) {
        return (options.client ?? client).put<CoContributionDefaultsUpsertDefaultResponses, CoContributionDefaultsUpsertDefaultErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/co-contribution-defaults/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Default
     */
    public static deleteDefault<ThrowOnError extends boolean = true>(options: Options<CoContributionDefaultsDeleteDefaultData, ThrowOnError>) {
        return (options.client ?? client).delete<CoContributionDefaultsDeleteDefaultResponses, CoContributionDefaultsDeleteDefaultErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/co-contribution-defaults/{id}',
            ...options
        });
    }
}

export class ProviderClientCoContributions {
    /**
     * List Client Co Contributions
     */
    public static listClientCoContributions<ThrowOnError extends boolean = true>(options: Options<ProviderClientCoContributionsListClientCoContributionsData, ThrowOnError>) {
        return (options.client ?? client).get<ProviderClientCoContributionsListClientCoContributionsResponses, ProviderClientCoContributionsListClientCoContributionsErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-client-co-contributions/',
            ...options
        });
    }
    
    /**
     * Upsert Client Co Contribution
     */
    public static upsertClientCoContribution<ThrowOnError extends boolean = true>(options: Options<ProviderClientCoContributionsUpsertClientCoContributionData, ThrowOnError>) {
        return (options.client ?? client).put<ProviderClientCoContributionsUpsertClientCoContributionResponses, ProviderClientCoContributionsUpsertClientCoContributionErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-client-co-contributions/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Client Co Contribution
     */
    public static deleteClientCoContribution<ThrowOnError extends boolean = true>(options: Options<ProviderClientCoContributionsDeleteClientCoContributionData, ThrowOnError>) {
        return (options.client ?? client).delete<ProviderClientCoContributionsDeleteClientCoContributionResponses, ProviderClientCoContributionsDeleteClientCoContributionErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-client-co-contributions/{id}',
            ...options
        });
    }
}

export class BudgetCategoryTypes {
    /**
     * List Budget Category Types
     */
    public static listBudgetCategoryTypes<ThrowOnError extends boolean = true>(options?: Options<BudgetCategoryTypesListBudgetCategoryTypesData, ThrowOnError>) {
        return (options?.client ?? client).get<BudgetCategoryTypesListBudgetCategoryTypesResponses, BudgetCategoryTypesListBudgetCategoryTypesErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/budget-category-types/',
            ...options
        });
    }
    
    /**
     * Create Budget Category Type
     */
    public static createBudgetCategoryType<ThrowOnError extends boolean = true>(options: Options<BudgetCategoryTypesCreateBudgetCategoryTypeData, ThrowOnError>) {
        return (options.client ?? client).post<BudgetCategoryTypesCreateBudgetCategoryTypeResponses, BudgetCategoryTypesCreateBudgetCategoryTypeErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/budget-category-types/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Budget Category Type
     */
    public static deleteBudgetCategoryType<ThrowOnError extends boolean = true>(options: Options<BudgetCategoryTypesDeleteBudgetCategoryTypeData, ThrowOnError>) {
        return (options.client ?? client).delete<BudgetCategoryTypesDeleteBudgetCategoryTypeResponses, BudgetCategoryTypesDeleteBudgetCategoryTypeErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/budget-category-types/{id}',
            ...options
        });
    }
    
    /**
     * Get Budget Category Type
     */
    public static getBudgetCategoryType<ThrowOnError extends boolean = true>(options: Options<BudgetCategoryTypesGetBudgetCategoryTypeData, ThrowOnError>) {
        return (options.client ?? client).get<BudgetCategoryTypesGetBudgetCategoryTypeResponses, BudgetCategoryTypesGetBudgetCategoryTypeErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/budget-category-types/{id}',
            ...options
        });
    }
    
    /**
     * Update Budget Category Type
     */
    public static updateBudgetCategoryType<ThrowOnError extends boolean = true>(options: Options<BudgetCategoryTypesUpdateBudgetCategoryTypeData, ThrowOnError>) {
        return (options.client ?? client).put<BudgetCategoryTypesUpdateBudgetCategoryTypeResponses, BudgetCategoryTypesUpdateBudgetCategoryTypeErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/budget-category-types/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class ClientAllowedServiceTypes {
    /**
     * List Allowed Service Types
     */
    public static listAllowedServiceTypes<ThrowOnError extends boolean = true>(options: Options<ClientAllowedServiceTypesListAllowedServiceTypesData, ThrowOnError>) {
        return (options.client ?? client).get<ClientAllowedServiceTypesListAllowedServiceTypesResponses, ClientAllowedServiceTypesListAllowedServiceTypesErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/client-allowed-service-types/',
            ...options
        });
    }
    
    /**
     * Add Allowed Service Type
     */
    public static addAllowedServiceType<ThrowOnError extends boolean = true>(options: Options<ClientAllowedServiceTypesAddAllowedServiceTypeData, ThrowOnError>) {
        return (options.client ?? client).post<ClientAllowedServiceTypesAddAllowedServiceTypeResponses, ClientAllowedServiceTypesAddAllowedServiceTypeErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/client-allowed-service-types/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Apply Client Type
     *
     * Set the client's type and reseed their allowed service types from the type's defaults.
     * Clears all existing allowed service types first, then adds defaults for the new type.
     * Passing providerClientTypeId=null clears the type and all allowed services.
     */
    public static applyClientType<ThrowOnError extends boolean = true>(options: Options<ClientAllowedServiceTypesApplyClientTypeData, ThrowOnError>) {
        return (options.client ?? client).post<ClientAllowedServiceTypesApplyClientTypeResponses, ClientAllowedServiceTypesApplyClientTypeErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/client-allowed-service-types/apply-client-type',
            ...options
        });
    }
    
    /**
     * Remove Allowed Service Type
     */
    public static removeAllowedServiceType<ThrowOnError extends boolean = true>(options: Options<ClientAllowedServiceTypesRemoveAllowedServiceTypeData, ThrowOnError>) {
        return (options.client ?? client).delete<ClientAllowedServiceTypesRemoveAllowedServiceTypeResponses, ClientAllowedServiceTypesRemoveAllowedServiceTypeErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/client-allowed-service-types/{id}',
            ...options
        });
    }
}

export class ClientBudgets {
    /**
     * Create Client Budget
     */
    public static createClientBudget<ThrowOnError extends boolean = true>(options: Options<ClientBudgetsCreateClientBudgetData, ThrowOnError>) {
        return (options.client ?? client).post<ClientBudgetsCreateClientBudgetResponses, ClientBudgetsCreateClientBudgetErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/client-budgets/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List Client Budgets
     */
    public static listClientBudgets<ThrowOnError extends boolean = true>(options: Options<ClientBudgetsListClientBudgetsData, ThrowOnError>) {
        return (options.client ?? client).get<ClientBudgetsListClientBudgetsResponses, ClientBudgetsListClientBudgetsErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/client-budgets/provider-client/{providerClientId}',
            ...options
        });
    }
    
    /**
     * Delete Client Budget
     */
    public static deleteClientBudget<ThrowOnError extends boolean = true>(options: Options<ClientBudgetsDeleteClientBudgetData, ThrowOnError>) {
        return (options.client ?? client).delete<ClientBudgetsDeleteClientBudgetResponses, ClientBudgetsDeleteClientBudgetErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/client-budgets/{budgetId}',
            ...options
        });
    }
    
    /**
     * Get Client Budget
     */
    public static getClientBudget<ThrowOnError extends boolean = true>(options: Options<ClientBudgetsGetClientBudgetData, ThrowOnError>) {
        return (options.client ?? client).get<ClientBudgetsGetClientBudgetResponses, ClientBudgetsGetClientBudgetErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/client-budgets/{budgetId}',
            ...options
        });
    }
    
    /**
     * Update Client Budget
     */
    public static updateClientBudget<ThrowOnError extends boolean = true>(options: Options<ClientBudgetsUpdateClientBudgetData, ThrowOnError>) {
        return (options.client ?? client).put<ClientBudgetsUpdateClientBudgetResponses, ClientBudgetsUpdateClientBudgetErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/client-budgets/{budgetId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class ProviderClientTypes {
    /**
     * List client types for a provider
     *
     * Returns all client types belonging to the given provider. Available to all authenticated members of the provider.
     */
    public static listProviderClientTypes<ThrowOnError extends boolean = true>(options: Options<ProviderClientTypesListProviderClientTypesData, ThrowOnError>) {
        return (options.client ?? client).get<ProviderClientTypesListProviderClientTypesResponses, ProviderClientTypesListProviderClientTypesErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-client-types/',
            ...options
        });
    }
    
    /**
     * Create a client type
     *
     * Creates a new client type for the provider. Requires ProviderAdmin or above.
     */
    public static createProviderClientType<ThrowOnError extends boolean = true>(options: Options<ProviderClientTypesCreateProviderClientTypeData, ThrowOnError>) {
        return (options.client ?? client).post<ProviderClientTypesCreateProviderClientTypeResponses, ProviderClientTypesCreateProviderClientTypeErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-client-types/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete a client type
     *
     * Deletes a client type. Requires ProviderAdmin or above.
     */
    public static deleteProviderClientType<ThrowOnError extends boolean = true>(options: Options<ProviderClientTypesDeleteProviderClientTypeData, ThrowOnError>) {
        return (options.client ?? client).delete<ProviderClientTypesDeleteProviderClientTypeResponses, ProviderClientTypesDeleteProviderClientTypeErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-client-types/{id}',
            ...options
        });
    }
    
    /**
     * Update a client type
     *
     * Updates a client type. Requires ProviderAdmin or above.
     */
    public static updateProviderClientType<ThrowOnError extends boolean = true>(options: Options<ProviderClientTypesUpdateProviderClientTypeData, ThrowOnError>) {
        return (options.client ?? client).put<ProviderClientTypesUpdateProviderClientTypeResponses, ProviderClientTypesUpdateProviderClientTypeErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-client-types/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List default service types for a client type
     *
     * Returns service types automatically assigned to new clients of this type. Available to SuperUser, ProviderAdmin, and ProviderGroupAdmin.
     */
    public static listServiceDefaults<ThrowOnError extends boolean = true>(options: Options<ProviderClientTypesListServiceDefaultsData, ThrowOnError>) {
        return (options.client ?? client).get<ProviderClientTypesListServiceDefaultsResponses, ProviderClientTypesListServiceDefaultsErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-client-types/{id}/service-defaults',
            ...options
        });
    }
    
    /**
     * Add a default service type to a client type
     *
     * Adds a service type as a default for new clients of this type. Idempotent — returns the existing record if the association already exists. Requires ProviderAdmin or above.
     */
    public static addServiceDefault<ThrowOnError extends boolean = true>(options: Options<ProviderClientTypesAddServiceDefaultData, ThrowOnError>) {
        return (options.client ?? client).post<ProviderClientTypesAddServiceDefaultResponses, ProviderClientTypesAddServiceDefaultErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-client-types/{id}/service-defaults',
            ...options
        });
    }
    
    /**
     * Remove a default service type from a client type
     *
     * Requires ProviderAdmin or above.
     */
    public static removeServiceDefault<ThrowOnError extends boolean = true>(options: Options<ProviderClientTypesRemoveServiceDefaultData, ThrowOnError>) {
        return (options.client ?? client).delete<ProviderClientTypesRemoveServiceDefaultResponses, ProviderClientTypesRemoveServiceDefaultErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-client-types/{id}/service-defaults/{defaultId}',
            ...options
        });
    }
    
    /**
     * List surveys assigned to a client type
     *
     * Returns survey associations for the given client type. Available to SuperUser, ProviderAdmin, and ProviderGroupAdmin.
     */
    public static listClientTypeSurveys<ThrowOnError extends boolean = true>(options: Options<ProviderClientTypesListClientTypeSurveysData, ThrowOnError>) {
        return (options.client ?? client).get<ProviderClientTypesListClientTypeSurveysResponses, ProviderClientTypesListClientTypeSurveysErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-client-types/{id}/surveys',
            ...options
        });
    }
    
    /**
     * Remove a survey from a client type
     *
     * Requires ProviderAdmin or above.
     */
    public static removeClientTypeSurvey<ThrowOnError extends boolean = true>(options: Options<ProviderClientTypesRemoveClientTypeSurveyData, ThrowOnError>) {
        return (options.client ?? client).delete<ProviderClientTypesRemoveClientTypeSurveyResponses, ProviderClientTypesRemoveClientTypeSurveyErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-client-types/{id}/surveys/{surveyId}',
            ...options
        });
    }
    
    /**
     * Assign a survey to a client type
     *
     * Enables the survey for all clients of this type. Idempotent — returns the existing record if already assigned. Requires ProviderAdmin or above.
     */
    public static addClientTypeSurvey<ThrowOnError extends boolean = true>(options: Options<ProviderClientTypesAddClientTypeSurveyData, ThrowOnError>) {
        return (options.client ?? client).post<ProviderClientTypesAddClientTypeSurveyResponses, ProviderClientTypesAddClientTypeSurveyErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-client-types/{id}/surveys/{surveyId}',
            ...options
        });
    }
}

export class ProviderUserTypes {
    /**
     * List Provider User Types
     */
    public static listProviderUserTypes<ThrowOnError extends boolean = true>(options: Options<ProviderUserTypesListProviderUserTypesData, ThrowOnError>) {
        return (options.client ?? client).get<ProviderUserTypesListProviderUserTypesResponses, ProviderUserTypesListProviderUserTypesErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-user-types/',
            ...options
        });
    }
    
    /**
     * Create Provider User Type
     */
    public static createProviderUserType<ThrowOnError extends boolean = true>(options: Options<ProviderUserTypesCreateProviderUserTypeData, ThrowOnError>) {
        return (options.client ?? client).post<ProviderUserTypesCreateProviderUserTypeResponses, ProviderUserTypesCreateProviderUserTypeErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-user-types/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Provider User Type
     */
    public static deleteProviderUserType<ThrowOnError extends boolean = true>(options: Options<ProviderUserTypesDeleteProviderUserTypeData, ThrowOnError>) {
        return (options.client ?? client).delete<ProviderUserTypesDeleteProviderUserTypeResponses, ProviderUserTypesDeleteProviderUserTypeErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-user-types/{id}',
            ...options
        });
    }
    
    /**
     * Update Provider User Type
     */
    public static updateProviderUserType<ThrowOnError extends boolean = true>(options: Options<ProviderUserTypesUpdateProviderUserTypeData, ThrowOnError>) {
        return (options.client ?? client).put<ProviderUserTypesUpdateProviderUserTypeResponses, ProviderUserTypesUpdateProviderUserTypeErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-user-types/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class ProviderItemOverrides {
    /**
     * List Overrides By Provider
     */
    public static listOverridesByProvider<ThrowOnError extends boolean = true>(options: Options<ProviderItemOverridesListOverridesByProviderData, ThrowOnError>) {
        return (options.client ?? client).get<ProviderItemOverridesListOverridesByProviderResponses, ProviderItemOverridesListOverridesByProviderErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-item-overrides/provider/{providerId}',
            ...options
        });
    }
    
    /**
     * Delete Override
     */
    public static deleteOverride<ThrowOnError extends boolean = true>(options: Options<ProviderItemOverridesDeleteOverrideData, ThrowOnError>) {
        return (options.client ?? client).delete<ProviderItemOverridesDeleteOverrideResponses, ProviderItemOverridesDeleteOverrideErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-item-overrides/{id}',
            ...options
        });
    }
    
    /**
     * Get Override
     */
    public static getOverride<ThrowOnError extends boolean = true>(options: Options<ProviderItemOverridesGetOverrideData, ThrowOnError>) {
        return (options.client ?? client).get<ProviderItemOverridesGetOverrideResponses, ProviderItemOverridesGetOverrideErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-item-overrides/{id}',
            ...options
        });
    }
    
    /**
     * Update Override
     */
    public static updateOverride<ThrowOnError extends boolean = true>(options: Options<ProviderItemOverridesUpdateOverrideData, ThrowOnError>) {
        return (options.client ?? client).put<ProviderItemOverridesUpdateOverrideResponses, ProviderItemOverridesUpdateOverrideErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-item-overrides/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Create Override
     */
    public static createOverride<ThrowOnError extends boolean = true>(options: Options<ProviderItemOverridesCreateOverrideData, ThrowOnError>) {
        return (options.client ?? client).post<ProviderItemOverridesCreateOverrideResponses, ProviderItemOverridesCreateOverrideErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-item-overrides/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class SupportAtHomeClassifications {
    /**
     * List Classifications
     */
    public static listClassifications<ThrowOnError extends boolean = true>(options?: Options<SupportAtHomeClassificationsListClassificationsData, ThrowOnError>) {
        return (options?.client ?? client).get<SupportAtHomeClassificationsListClassificationsResponses, unknown, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/support-at-home-classifications/',
            ...options
        });
    }
}

export class ServiceCatalog {
    /**
     * List Subcategories By Provider
     */
    public static listSubcategoriesByProvider<ThrowOnError extends boolean = true>(options: Options<ServiceCatalogListSubcategoriesByProviderData, ThrowOnError>) {
        return (options.client ?? client).get<ServiceCatalogListSubcategoriesByProviderResponses, ServiceCatalogListSubcategoriesByProviderErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/service-catalog/subcategories/provider/{providerId}',
            ...options
        });
    }
    
    /**
     * Delete Subcategory
     */
    public static deleteSubcategory<ThrowOnError extends boolean = true>(options: Options<ServiceCatalogDeleteSubcategoryData, ThrowOnError>) {
        return (options.client ?? client).delete<ServiceCatalogDeleteSubcategoryResponses, ServiceCatalogDeleteSubcategoryErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/service-catalog/subcategories/{subCategoryId}',
            ...options
        });
    }
    
    /**
     * Get Subcategory
     */
    public static getSubcategory<ThrowOnError extends boolean = true>(options: Options<ServiceCatalogGetSubcategoryData, ThrowOnError>) {
        return (options.client ?? client).get<ServiceCatalogGetSubcategoryResponses, ServiceCatalogGetSubcategoryErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/service-catalog/subcategories/{subCategoryId}',
            ...options
        });
    }
    
    /**
     * Update Subcategory
     */
    public static updateSubcategory<ThrowOnError extends boolean = true>(options: Options<ServiceCatalogUpdateSubcategoryData, ThrowOnError>) {
        return (options.client ?? client).put<ServiceCatalogUpdateSubcategoryResponses, ServiceCatalogUpdateSubcategoryErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/service-catalog/subcategories/{subCategoryId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Create Subcategory
     */
    public static createSubcategory<ThrowOnError extends boolean = true>(options: Options<ServiceCatalogCreateSubcategoryData, ThrowOnError>) {
        return (options.client ?? client).post<ServiceCatalogCreateSubcategoryResponses, ServiceCatalogCreateSubcategoryErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/service-catalog/subcategories',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List Items For Current User
     *
     * Return all service items the current user is skilled to deliver, with rate enrichment.
     * When providerClientId is supplied, also returns client co-contribution overrides so the
     * caller doesn't need a separate (potentially forbidden) co-contributions request.
     */
    public static listItemsForCurrentUser<ThrowOnError extends boolean = true>(options?: Options<ServiceCatalogListItemsForCurrentUserData, ThrowOnError>) {
        return (options?.client ?? client).get<ServiceCatalogListItemsForCurrentUserResponses, ServiceCatalogListItemsForCurrentUserErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/service-catalog/items/for-current-user',
            ...options
        });
    }
    
    /**
     * List Items For Client
     *
     * Return all service items allocated to a specific client, with provider rate enrichment.
     */
    public static listItemsForClient<ThrowOnError extends boolean = true>(options: Options<ServiceCatalogListItemsForClientData, ThrowOnError>) {
        return (options.client ?? client).get<ServiceCatalogListItemsForClientResponses, ServiceCatalogListItemsForClientErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/service-catalog/items/for-client',
            ...options
        });
    }
    
    /**
     * List Items By Subcategory
     */
    public static listItemsBySubcategory<ThrowOnError extends boolean = true>(options: Options<ServiceCatalogListItemsBySubcategoryData, ThrowOnError>) {
        return (options.client ?? client).get<ServiceCatalogListItemsBySubcategoryResponses, ServiceCatalogListItemsBySubcategoryErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/service-catalog/items/subcategory/{subCategoryId}',
            ...options
        });
    }
    
    /**
     * Delete Service Item
     */
    public static deleteServiceItem<ThrowOnError extends boolean = true>(options: Options<ServiceCatalogDeleteServiceItemData, ThrowOnError>) {
        return (options.client ?? client).delete<ServiceCatalogDeleteServiceItemResponses, ServiceCatalogDeleteServiceItemErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/service-catalog/items/{serviceItemId}',
            ...options
        });
    }
    
    /**
     * Get Service Item
     */
    public static getServiceItem<ThrowOnError extends boolean = true>(options: Options<ServiceCatalogGetServiceItemData, ThrowOnError>) {
        return (options.client ?? client).get<ServiceCatalogGetServiceItemResponses, ServiceCatalogGetServiceItemErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/service-catalog/items/{serviceItemId}',
            ...options
        });
    }
    
    /**
     * Update Service Item
     */
    public static updateServiceItem<ThrowOnError extends boolean = true>(options: Options<ServiceCatalogUpdateServiceItemData, ThrowOnError>) {
        return (options.client ?? client).put<ServiceCatalogUpdateServiceItemResponses, ServiceCatalogUpdateServiceItemErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/service-catalog/items/{serviceItemId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Create Service Item
     */
    public static createServiceItem<ThrowOnError extends boolean = true>(options: Options<ServiceCatalogCreateServiceItemData, ThrowOnError>) {
        return (options.client ?? client).post<ServiceCatalogCreateServiceItemResponses, ServiceCatalogCreateServiceItemErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/service-catalog/items',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List Items For User Type
     *
     * Return all service item assignments for a given provider user type.
     */
    public static listItemsForUserType<ThrowOnError extends boolean = true>(options: Options<ServiceCatalogListItemsForUserTypeData, ThrowOnError>) {
        return (options.client ?? client).get<ServiceCatalogListItemsForUserTypeResponses, ServiceCatalogListItemsForUserTypeErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/service-catalog/user-types/{providerUserTypeId}/items',
            ...options
        });
    }
    
    /**
     * List Item User Types
     */
    public static listItemUserTypes<ThrowOnError extends boolean = true>(options: Options<ServiceCatalogListItemUserTypesData, ThrowOnError>) {
        return (options.client ?? client).get<ServiceCatalogListItemUserTypesResponses, ServiceCatalogListItemUserTypesErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/service-catalog/items/{serviceItemId}/user-types',
            ...options
        });
    }
    
    /**
     * Remove Item User Type
     */
    public static removeItemUserType<ThrowOnError extends boolean = true>(options: Options<ServiceCatalogRemoveItemUserTypeData, ThrowOnError>) {
        return (options.client ?? client).delete<ServiceCatalogRemoveItemUserTypeResponses, ServiceCatalogRemoveItemUserTypeErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/service-catalog/items/{serviceItemId}/user-types/{providerUserTypeId}',
            ...options
        });
    }
    
    /**
     * Add Item User Type
     */
    public static addItemUserType<ThrowOnError extends boolean = true>(options: Options<ServiceCatalogAddItemUserTypeData, ThrowOnError>) {
        return (options.client ?? client).post<ServiceCatalogAddItemUserTypeResponses, ServiceCatalogAddItemUserTypeErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/service-catalog/items/{serviceItemId}/user-types/{providerUserTypeId}',
            ...options
        });
    }
}

export class PurchaseCatalog {
    /**
     * List Purchase Items By Provider
     */
    public static listPurchaseItemsByProvider<ThrowOnError extends boolean = true>(options: Options<PurchaseCatalogListPurchaseItemsByProviderData, ThrowOnError>) {
        return (options.client ?? client).get<PurchaseCatalogListPurchaseItemsByProviderResponses, PurchaseCatalogListPurchaseItemsByProviderErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/purchase-catalog/items/provider/{providerId}',
            ...options
        });
    }
    
    /**
     * List Purchase Items By Subcategory
     */
    public static listPurchaseItemsBySubcategory<ThrowOnError extends boolean = true>(options: Options<PurchaseCatalogListPurchaseItemsBySubcategoryData, ThrowOnError>) {
        return (options.client ?? client).get<PurchaseCatalogListPurchaseItemsBySubcategoryResponses, PurchaseCatalogListPurchaseItemsBySubcategoryErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/purchase-catalog/items/subcategory/{subCategoryId}',
            ...options
        });
    }
    
    /**
     * Delete Purchase Item
     */
    public static deletePurchaseItem<ThrowOnError extends boolean = true>(options: Options<PurchaseCatalogDeletePurchaseItemData, ThrowOnError>) {
        return (options.client ?? client).delete<PurchaseCatalogDeletePurchaseItemResponses, PurchaseCatalogDeletePurchaseItemErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/purchase-catalog/items/{purchaseItemId}',
            ...options
        });
    }
    
    /**
     * Get Purchase Item
     */
    public static getPurchaseItem<ThrowOnError extends boolean = true>(options: Options<PurchaseCatalogGetPurchaseItemData, ThrowOnError>) {
        return (options.client ?? client).get<PurchaseCatalogGetPurchaseItemResponses, PurchaseCatalogGetPurchaseItemErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/purchase-catalog/items/{purchaseItemId}',
            ...options
        });
    }
    
    /**
     * Update Purchase Item
     */
    public static updatePurchaseItem<ThrowOnError extends boolean = true>(options: Options<PurchaseCatalogUpdatePurchaseItemData, ThrowOnError>) {
        return (options.client ?? client).put<PurchaseCatalogUpdatePurchaseItemResponses, PurchaseCatalogUpdatePurchaseItemErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/purchase-catalog/items/{purchaseItemId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Create Purchase Item
     */
    public static createPurchaseItem<ThrowOnError extends boolean = true>(options: Options<PurchaseCatalogCreatePurchaseItemData, ThrowOnError>) {
        return (options.client ?? client).post<PurchaseCatalogCreatePurchaseItemResponses, PurchaseCatalogCreatePurchaseItemErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/purchase-catalog/items',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class ServiceItemDelivered {
    /**
     * Create Service Item Delivered
     */
    public static createServiceItemDelivered<ThrowOnError extends boolean = true>(options: Options<ServiceItemDeliveredCreateServiceItemDeliveredData, ThrowOnError>) {
        return (options.client ?? client).post<ServiceItemDeliveredCreateServiceItemDeliveredResponses, ServiceItemDeliveredCreateServiceItemDeliveredErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/service-item-delivered/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete Service Item Delivered
     */
    public static deleteServiceItemDelivered<ThrowOnError extends boolean = true>(options: Options<ServiceItemDeliveredDeleteServiceItemDeliveredData, ThrowOnError>) {
        return (options.client ?? client).delete<ServiceItemDeliveredDeleteServiceItemDeliveredResponses, ServiceItemDeliveredDeleteServiceItemDeliveredErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/service-item-delivered/{serviceItemDeliveredId}',
            ...options
        });
    }
    
    /**
     * Get Service Item Delivered
     */
    public static getServiceItemDelivered<ThrowOnError extends boolean = true>(options: Options<ServiceItemDeliveredGetServiceItemDeliveredData, ThrowOnError>) {
        return (options.client ?? client).get<ServiceItemDeliveredGetServiceItemDeliveredResponses, ServiceItemDeliveredGetServiceItemDeliveredErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/service-item-delivered/{serviceItemDeliveredId}',
            ...options
        });
    }
    
    /**
     * Update Service Item Delivered
     */
    public static updateServiceItemDelivered<ThrowOnError extends boolean = true>(options: Options<ServiceItemDeliveredUpdateServiceItemDeliveredData, ThrowOnError>) {
        return (options.client ?? client).put<ServiceItemDeliveredUpdateServiceItemDeliveredResponses, ServiceItemDeliveredUpdateServiceItemDeliveredErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/service-item-delivered/{serviceItemDeliveredId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List Service Items Delivered By Provider Client
     */
    public static listServiceItemsDeliveredByProviderClient<ThrowOnError extends boolean = true>(options: Options<ServiceItemDeliveredListServiceItemsDeliveredByProviderClientData, ThrowOnError>) {
        return (options.client ?? client).get<ServiceItemDeliveredListServiceItemsDeliveredByProviderClientResponses, ServiceItemDeliveredListServiceItemsDeliveredByProviderClientErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/service-item-delivered/provider-client/{providerClientId}',
            ...options
        });
    }
    
    /**
     * List Service Item Delivered Audit
     */
    public static listServiceItemDeliveredAudit<ThrowOnError extends boolean = true>(options: Options<ServiceItemDeliveredListServiceItemDeliveredAuditData, ThrowOnError>) {
        return (options.client ?? client).get<ServiceItemDeliveredListServiceItemDeliveredAuditResponses, ServiceItemDeliveredListServiceItemDeliveredAuditErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/service-item-delivered/{serviceItemDeliveredId}/audit',
            ...options
        });
    }
}

export class ServiceItemProviderRates {
    /**
     * Delete Rate
     */
    public static deleteRate<ThrowOnError extends boolean = true>(options: Options<ServiceItemProviderRatesDeleteRateData, ThrowOnError>) {
        return (options.client ?? client).delete<ServiceItemProviderRatesDeleteRateResponses, ServiceItemProviderRatesDeleteRateErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/service-item-provider-rates/item/{serviceItemId}/provider/{providerId}',
            ...options
        });
    }
    
    /**
     * Get Rate
     */
    public static getRate<ThrowOnError extends boolean = true>(options: Options<ServiceItemProviderRatesGetRateData, ThrowOnError>) {
        return (options.client ?? client).get<ServiceItemProviderRatesGetRateResponses, ServiceItemProviderRatesGetRateErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/service-item-provider-rates/item/{serviceItemId}/provider/{providerId}',
            ...options
        });
    }
    
    /**
     * Upsert Rate
     */
    public static upsertRate<ThrowOnError extends boolean = true>(options: Options<ServiceItemProviderRatesUpsertRateData, ThrowOnError>) {
        return (options.client ?? client).put<ServiceItemProviderRatesUpsertRateResponses, ServiceItemProviderRatesUpsertRateErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/service-item-provider-rates/item/{serviceItemId}/provider/{providerId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get Audit
     */
    public static getAudit<ThrowOnError extends boolean = true>(options: Options<ServiceItemProviderRatesGetAuditData, ThrowOnError>) {
        return (options.client ?? client).get<ServiceItemProviderRatesGetAuditResponses, ServiceItemProviderRatesGetAuditErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/service-item-provider-rates/item/{serviceItemId}/provider/{providerId}/audit',
            ...options
        });
    }
}

export class Surveys {
    /**
     * List surveys
     *
     * Returns surveys visible to the caller. Superusers may omit `providerId` to retrieve all surveys, or supply it to filter. Non-superusers must supply `providerId` and must belong to that provider; they receive global surveys plus surveys for that provider only. Without `providerId`, non-superusers receive only global surveys.
     */
    public static readSurveys<ThrowOnError extends boolean = true>(options?: Options<SurveysReadSurveysData, ThrowOnError>) {
        return (options?.client ?? client).get<SurveysReadSurveysResponses, SurveysReadSurveysErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/surveys/',
            ...options
        });
    }
    
    /**
     * Create a survey
     *
     * Provider admins and group admins may create provider-scoped surveys. Only superusers may create global surveys (`isGlobal: true`).
     */
    public static createSurvey<ThrowOnError extends boolean = true>(options: Options<SurveysCreateSurveyData, ThrowOnError>) {
        return (options.client ?? client).post<SurveysCreateSurveyResponses, SurveysCreateSurveyErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/surveys/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete a survey
     *
     * Superusers may delete any survey. Provider admins may only delete provider-scoped surveys they own.
     */
    public static deleteSurvey<ThrowOnError extends boolean = true>(options: Options<SurveysDeleteSurveyData, ThrowOnError>) {
        return (options.client ?? client).delete<SurveysDeleteSurveyResponses, SurveysDeleteSurveyErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/surveys/{survey_id}',
            ...options
        });
    }
    
    /**
     * Get a survey with all questions and options
     *
     * Returns a single survey including all nested questions and answer options. Superusers can access any survey. Non-superusers can access global surveys freely. For provider-scoped surveys, the caller must be a member of that provider.
     */
    public static readSurvey<ThrowOnError extends boolean = true>(options: Options<SurveysReadSurveyData, ThrowOnError>) {
        return (options.client ?? client).get<SurveysReadSurveyResponses, SurveysReadSurveyErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/surveys/{survey_id}',
            ...options
        });
    }
    
    /**
     * Update a survey
     *
     * Superusers may update any survey. Provider admins may only update surveys scoped to their provider — global surveys are read-only for non-superusers. Setting `isGlobal: true` requires superuser.
     */
    public static updateSurvey<ThrowOnError extends boolean = true>(options: Options<SurveysUpdateSurveyData, ThrowOnError>) {
        return (options.client ?? client).put<SurveysUpdateSurveyResponses, SurveysUpdateSurveyErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/surveys/{survey_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Add a question to a survey
     *
     * Requires write access to the parent survey. The `surveyId` in the body must match the path parameter.
     */
    public static createSurveyQuestion<ThrowOnError extends boolean = true>(options: Options<SurveysCreateSurveyQuestionData, ThrowOnError>) {
        return (options.client ?? client).post<SurveysCreateSurveyQuestionResponses, SurveysCreateSurveyQuestionErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/surveys/{survey_id}/questions',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete a survey question
     *
     * Requires write access to the parent survey. Also deletes all answer options for this question.
     */
    public static deleteSurveyQuestion<ThrowOnError extends boolean = true>(options: Options<SurveysDeleteSurveyQuestionData, ThrowOnError>) {
        return (options.client ?? client).delete<SurveysDeleteSurveyQuestionResponses, SurveysDeleteSurveyQuestionErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/surveys/questions/{survey_question_id}',
            ...options
        });
    }
    
    /**
     * Update a survey question
     *
     * Requires write access to the parent survey.
     */
    public static updateSurveyQuestion<ThrowOnError extends boolean = true>(options: Options<SurveysUpdateSurveyQuestionData, ThrowOnError>) {
        return (options.client ?? client).put<SurveysUpdateSurveyQuestionResponses, SurveysUpdateSurveyQuestionErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/surveys/questions/{survey_question_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Add an answer option to a question
     *
     * Requires write access to the grandparent survey. The `questionId` in the body must match the path parameter.
     */
    public static createSurveyQuestionOption<ThrowOnError extends boolean = true>(options: Options<SurveysCreateSurveyQuestionOptionData, ThrowOnError>) {
        return (options.client ?? client).post<SurveysCreateSurveyQuestionOptionResponses, SurveysCreateSurveyQuestionOptionErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/surveys/questions/{survey_question_id}/options',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Delete an answer option
     *
     * Requires write access to the grandparent survey.
     */
    public static deleteSurveyQuestionOption<ThrowOnError extends boolean = true>(options: Options<SurveysDeleteSurveyQuestionOptionData, ThrowOnError>) {
        return (options.client ?? client).delete<SurveysDeleteSurveyQuestionOptionResponses, SurveysDeleteSurveyQuestionOptionErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/surveys/options/{survey_question_option_id}',
            ...options
        });
    }
    
    /**
     * Update an answer option
     *
     * Requires write access to the grandparent survey.
     */
    public static updateSurveyQuestionOption<ThrowOnError extends boolean = true>(options: Options<SurveysUpdateSurveyQuestionOptionData, ThrowOnError>) {
        return (options.client ?? client).put<SurveysUpdateSurveyQuestionOptionResponses, SurveysUpdateSurveyQuestionOptionErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/surveys/options/{survey_question_option_id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class SurveyResponses {
    /**
     * List survey responses
     *
     * Returns survey responses with their full question answers. Results are automatically filtered to clients the caller has group-level access to; responses for inaccessible clients are silently excluded. Optionally filter by surveyId or providerClientId.
     */
    public static listSurveyResponses<ThrowOnError extends boolean = true>(options?: Options<SurveyResponsesListSurveyResponsesData, ThrowOnError>) {
        return (options?.client ?? client).get<SurveyResponsesListSurveyResponsesResponses, SurveyResponsesListSurveyResponsesErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/survey-responses/',
            ...options
        });
    }
    
    /**
     * Submit a survey response
     *
     * Records answers to a survey for a given provider client. Provider members (any role) may submit on behalf of a client in their group. A client user may submit a self-survey for their own client record. The overall score is computed as the sum of all question scores.
     */
    public static submitSurveyResponse<ThrowOnError extends boolean = true>(options: Options<SurveyResponsesSubmitSurveyResponseData, ThrowOnError>) {
        return (options.client ?? client).post<SurveyResponsesSubmitSurveyResponseResponses, SurveyResponsesSubmitSurveyResponseErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/survey-responses/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get a survey response with answers
     *
     * Returns a single survey response including all question answers. Accessible to provider members (any role) who have group-level access to the client. A client user may access their own response. Returns 404 if the response does not exist.
     */
    public static getSurveyResponse<ThrowOnError extends boolean = true>(options: Options<SurveyResponsesGetSurveyResponseData, ThrowOnError>) {
        return (options.client ?? client).get<SurveyResponsesGetSurveyResponseResponses, SurveyResponsesGetSurveyResponseErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/survey-responses/{survey_response_id}',
            ...options
        });
    }
    
    /**
     * Get a survey response with answers grouped by question
     *
     * Returns a single survey response with answers nested under each question, including all answer options and which was selected. Same access rules as GET /{survey_response_id}.
     */
    public static getSurveyResponseGrouped<ThrowOnError extends boolean = true>(options: Options<SurveyResponsesGetSurveyResponseGroupedData, ThrowOnError>) {
        return (options.client ?? client).get<SurveyResponsesGetSurveyResponseGroupedResponses, SurveyResponsesGetSurveyResponseGroupedErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/survey-responses/{survey_response_id}/grouped',
            ...options
        });
    }
    
    /**
     * List survey responses grouped by client
     *
     * Returns survey responses grouped by provider client. Results are automatically filtered to clients the caller has group-level access to; responses for inaccessible clients are silently excluded. Optionally filter by surveyId, providerClientId, submittedByUserId, dateFrom, or dateTo.
     */
    public static listSurveyResponsesGroupedByProviderClient<ThrowOnError extends boolean = true>(options?: Options<SurveyResponsesListSurveyResponsesGroupedByProviderClientData, ThrowOnError>) {
        return (options?.client ?? client).get<SurveyResponsesListSurveyResponsesGroupedByProviderClientResponses, SurveyResponsesListSurveyResponsesGroupedByProviderClientErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/survey-responses/grouped/by-provider-client',
            ...options
        });
    }
}

export class ClientPurchases {
    /**
     * Create Purchase Order
     */
    public static createPurchaseOrder<ThrowOnError extends boolean = true>(options: Options<ClientPurchasesCreatePurchaseOrderData, ThrowOnError>) {
        return (options.client ?? client).post<ClientPurchasesCreatePurchaseOrderResponses, ClientPurchasesCreatePurchaseOrderErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/ClientPurchases/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * List Purchases By Client
     */
    public static listPurchasesByClient<ThrowOnError extends boolean = true>(options: Options<ClientPurchasesListPurchasesByClientData, ThrowOnError>) {
        return (options.client ?? client).get<ClientPurchasesListPurchasesByClientResponses, ClientPurchasesListPurchasesByClientErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/ClientPurchases/provider-client/{providerClientId}',
            ...options
        });
    }
    
    /**
     * Void Purchase
     */
    public static voidPurchase<ThrowOnError extends boolean = true>(options: Options<ClientPurchasesVoidPurchaseData, ThrowOnError>) {
        return (options.client ?? client).post<ClientPurchasesVoidPurchaseResponses, ClientPurchasesVoidPurchaseErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/ClientPurchases/{purchaseId}/void',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class ProviderUserGroups {
    /**
     * List provider user group memberships
     *
     * Returns group membership records for a provider. ProviderAdmin sees all memberships within the provider. ProviderGroupAdmin sees only memberships within groups they administer. Optionally filter by providerGroupId or providerUserId.
     */
    public static readProviderUserGroupMembership<ThrowOnError extends boolean = true>(options: Options<ProviderUserGroupsReadProviderUserGroupMembershipData, ThrowOnError>) {
        return (options.client ?? client).get<ProviderUserGroupsReadProviderUserGroupMembershipResponses, ProviderUserGroupsReadProviderUserGroupMembershipErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-user-group/',
            ...options
        });
    }
    
    /**
     * Add a provider user to a group
     *
     * Assigns a provider user to a group within the provider. ProviderGroupAdmin may only add to groups they administer.
     */
    public static addProviderUserToProviderGroup<ThrowOnError extends boolean = true>(options: Options<ProviderUserGroupsAddProviderUserToProviderGroupData, ThrowOnError>) {
        return (options.client ?? client).post<ProviderUserGroupsAddProviderUserToProviderGroupResponses, ProviderUserGroupsAddProviderUserToProviderGroupErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-user-group/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Remove a provider user from a group
     *
     * Removes a group membership record. ProviderGroupAdmin may only remove members from groups they administer.
     */
    public static removeProviderUserFromProviderGroup<ThrowOnError extends boolean = true>(options: Options<ProviderUserGroupsRemoveProviderUserFromProviderGroupData, ThrowOnError>) {
        return (options.client ?? client).delete<ProviderUserGroupsRemoveProviderUserFromProviderGroupResponses, ProviderUserGroupsRemoveProviderUserFromProviderGroupErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/provider-user-group/{id}',
            ...options
        });
    }
}

export class ProviderUserGroupsMembership {
    /**
     * Read Provider User Groups
     *
     * Get List of All Groups and Members.
     */
    public static readProviderUserGroups<ThrowOnError extends boolean = true>(options: Options<ProviderUserGroupsMembershipReadProviderUserGroupsData, ThrowOnError>) {
        return (options.client ?? client).get<ProviderUserGroupsMembershipReadProviderUserGroupsResponses, ProviderUserGroupsMembershipReadProviderUserGroupsErrors, ThrowOnError, 'data'>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/providerusergroupsmembership/',
            ...options
        });
    }
}

export class Private {
    /**
     * Create User
     *
     * Create a new user.
     */
    public static createUser<ThrowOnError extends boolean = true>(options: Options<PrivateCreateUserData, ThrowOnError>) {
        return (options.client ?? client).post<PrivateCreateUserResponses, PrivateCreateUserErrors, ThrowOnError, 'data'>({
            url: '/api/v1/private/users/',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
